export default __webpack_public_path__ + "static/media/objectives.aeaec9ae.png";